module.exports = __webpack_public_path__ + "img/BLUR.d629e93d.png";